import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import MenuListComposition from "./MenuListComposition";
import "./AccountMenu.css";
import headerLogo from "../images/header-logo.png";
import { useUser } from "../Provider/UserProvider";

export function AccountMenu() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const navigate = useNavigate();
  const { user, logoutUser } = useUser();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);

    // ページ遷移
    for (let i = 0; i < allItems.length; i++) {
      if (allItems[i][1] == event.target.textContent) {
        navigate(`/${allItems[i][0]}`);
        break;
      }
    }
  };

  const memberManagementItems = [
    ["EditMember", "メンバー編集"],
    ["EditGroup", "グループ編集"],
    ["EditOwnedGroup", "所属グループ編集"],
    ["ImportMemberCsv", "CSVファイル取り込み"],
    ["EditMeasurement", "測定データ編集"],
    // ["ImportJDCMembersCsv", "CSVファイル取り込みJDC用"],
  ];

  const allItems = [
    ["Report", "評価シート"],
    ["EditMember", "メンバー編集"],
    ["EditGroup", "グループ編集"],
    ["EditOwnedGroup", "所属グループ編集"],
    ["ImportMemberCsv", "CSVファイル取り込み"],
    ["EditMeasurement", "測定データ編集"],
    ["EditReportUser", "登録情報の確認・変更"],
    ["History", "利用状況"],
    // ["ImportJDCMembersCsv", "CSVファイル取り込みJDC用"],
  ];

  const logout = () => {
    const webToken = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith("hacaroWebToken="))
      ?.split("=")[1];

    logoutUser(webToken || "");
    navigate("/SignIn");
  };

  const headerBtns = () => {
    return (
      <>
        <Button
          variant="text"
          style={{ color: "white" }}
          onClick={() => {
            navigate("/Report");
          }}
        >
          評価シート
        </Button>
        <MenuListComposition
          title="データ管理"
          items={memberManagementItems}
        />
        <Button
          variant="text"
          style={{ color: "white" }}
          onClick={() => {
            navigate("/EditReportUser");
          }}
        >
          登録情報の確認・変更
        </Button>
        <Button
          variant="text"
          style={{ color: "white" }}
          onClick={() => {
            navigate("/History");
          }}
        >
          利用状況
        </Button>
      </>
    );
  };

  return (
    <AppBar position="static">
      <Container className="header-bar" maxWidth="100%">
        <Toolbar disableGutters>
          <Button
            variant="h6"
            component="div"
            style={{ color: "white" }}
            sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
            onClick={() => {
              navigate("/");
            }}
          >
            <img
              src={headerLogo}
              alt="headerLogo"
              style={{ maxHeight: "40px" }}
            />
          </Button>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {user && user.id && user.id != "error"
                ? allItems.map((item, i) => (
                    <MenuItem key={i} onClick={handleCloseNavMenu}>
                      <Typography textAlign="center">{item[1]}</Typography>
                    </MenuItem>
                  ))
                : null}
            </Menu>
          </Box>
          <Button
            variant="h6"
            component="div"
            style={{ color: "white" }}
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            onClick={() => {
              navigate("/");
            }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              style={{ color: "white" }}
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              Hacaro
            </Typography>
          </Button>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {user && user.id && user.id != "error" ? headerBtns() : headerBtns}
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <Button
              variant="text"
              style={{ color: "white" }}
              onClick={() => logout()}
            >
              ログアウト
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AccountMenu;
